import {Component, Inject, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from '../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {ClientFilterResult} from './client-filter-result';
import { TramsDataSourceModel } from '../../../payments/models/trams-data-source';
import { HttpClient } from '@angular/common/http';

@AutoUnsubscribe()
@Component({
    selector: 'client-filter-modal',
    templateUrl: './client-filter-modal.component.html',
    standalone: false
})
export class ClientFilterModalComponent implements OnInit {
  config: ClientFilterResult;

  form: FormGroup = new FormGroup({
    clientName: new FormControl(null),
    agentName: new FormControl(null),
    dataSource: new FormControl(null)
  });

  public datasources: TramsDataSourceModel[] = [];

  constructor(
    @Optional() public dialogRef: MatDialogRef<ClientFilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { config: ClientFilterResult },
    private http: HttpClient
  ) {
    this.config = data.config;
  }

  handleClientFiltersFormCloseEvent() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close(null);
  }

  protected get showDataSourceClearIcon() {
    return !!this.form.controls['dataSource'].value;
  }

  ngOnInit() {
    if (!this.config) {
      this.config = {} as ClientFilterResult;
    }
    this.patchFormValues();
    this.http.get<TramsDataSourceModel[]>('dbov2/trams-data-source').subscribe(
      (data) => {
        this.datasources = data;
      },
      (error) => {
        console.error('Failed to fetch datasources', error);
      }
    );
  }

  patchFormValues() {
    const { clientName, agentName, dataSource } = this.config;
    this.form.patchValue({
      clientName: clientName || null,
      agentName: agentName || null,
      dataSource: dataSource != null ? dataSource : null
    });
  }

  applyClientFilters() {
    this.updateConfig();
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else if (this.dialogRef) {
      this.dialogRef.close(this.config);
    }
  }

  updateConfig() {
    this.config.clientName = this.form.get('clientName')?.value;
    this.config.agentName = this.form.get('agentName')?.value;
    const dsValue = this.form.get('dataSource')?.value;
    this.config.dataSource = dsValue !== null && dsValue !== '' ? Number(dsValue) : undefined;
  }

  public clearClientFilters(propertyName: string): void {
    if (propertyName === 'all') {
      this.config = {} as ClientFilterResult;
      this.form.reset();
    } else {
      this.form.get(propertyName)?.setValue(null);
      
      const temp = { ...this.config };
      delete temp[propertyName as keyof ClientFilterResult];
      this.config = temp;
    }
  }
}
